import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function animateHomeNews(section, hr) {

  // Animated HR
  let hrTween = hr ? gsap.to(hr, {
    duration: 0.7,
    width: "100%",
    opacity: 1,
  }) : null;

}